import React, { useEffect, useRef, useState } from "react";
import { connect } from "react-redux";
import { QrReader } from "react-qr-reader";
import { getQRDetailsUsingScanner } from "../../action/qrcode";

const QRScanner = ({ qrCodeScanDetailsHandler }) => {
    const [cameraError, setCameraError] = useState("");
    const [hasVideo, setHasVideo] = useState(false);
    const qrContainerRef = useRef(null);

    const isIgnorableScannerError = (error) => {
        if (!error) return true;
        const errorMessage = (error.message || error.name || String(error)).toLowerCase();
        return (
            errorMessage.includes("notfound") ||
            errorMessage.includes("timeout") ||
            errorMessage.includes("no qr code") ||
            errorMessage.includes("no code found")
        );
    };

    const mapCameraError = (error) => {
        if (!error) return "";
        const errorName = error?.name || "";
        const errorMessage = error?.message || "";
        if (["NotAllowedError", "SecurityError"].includes(errorName)) {
            return "Camera permission is blocked. Please allow access to start scanning.";
        }
        if (["NotFoundError", "OverconstrainedError"].includes(errorName)) {
            return "No compatible camera found. Connect a camera and try again.";
        }
        if (["NotReadableError", "TrackStartError"].includes(errorName)) {
            return "Camera is in use or unavailable. Close other apps using the camera.";
        }
        if (errorMessage) {
            return "Unable to access the camera. Please check permissions and retry.";
        }
        return "";
    };

    const handleScanResult = (data) => {
        if (data) {
            getQRDetailsUsingScanner(data.text)
                .then((resp) => {
                    setCameraError("");
                    qrCodeScanDetailsHandler(resp);
                })
                .catch((error) => {
                    setCameraError("");
                    qrCodeScanDetailsHandler(undefined, error);
                });
        }
    };

    useEffect(() => {
        const container = qrContainerRef.current;
        if (!container) return;

        const video = container.querySelector("video");
        if (!video) return;

        const handleVideoStart = () => {
            setHasVideo(true);
            setCameraError("");
        };

        video.addEventListener("loadeddata", handleVideoStart);
        video.addEventListener("playing", handleVideoStart);

        return () => {
            video.removeEventListener("loadeddata", handleVideoStart);
            video.removeEventListener("playing", handleVideoStart);
        };
    }, []);

    return (
        <div
            ref={qrContainerRef}
            style={{
                width: "500px",
                maxWidth: "100%",
                height: "400px",
                marginTop: "-16px",
                position: "relative",
            }}
        >
            <QrReader
                constraints={{ facingMode: { ideal: "environment" } }}
                onResult={(result, error) => {
                    if (result) {
                        setCameraError("");
                        handleScanResult(result);
                        return;
                    }
                    if (error) {
                        if (isIgnorableScannerError(error)) return;
                        setCameraError(mapCameraError(error));
                    } else {
                        setCameraError("");
                    }
                }}
                containerStyle={{
                    width: "100%",
                    height: "100%",
                }}
                videoContainerStyle={{ paddingTop: "80%" }}
                videoStyle={{
                    width: "100%",
                    height: "100%",
                    transform: "none",
                }}
            />
            {cameraError && !hasVideo && (
                <div
                    style={{
                        position: "absolute",
                        inset: 0,
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "flex-start",
                        background: "rgba(255, 255, 255, 0.88)",
                        color: "#333",
                        textAlign: "left",
                        padding: "16px",
                        paddingLeft: "0px",
                        borderRadius: "4px",
                        fontSize: "14px",
                        lineHeight: 1.4,
                    }}
                    aria-live="polite"
                >
                    {cameraError}
                </div>
            )}
        </div>
    );
};

const mapStateToProps = () => ({});

export default connect(mapStateToProps)(QRScanner);
